/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Activity_Embedding_CompleteInputs */



/**
* | output |
* | --- |
* | "{name}: all files indexed" |
*
* @param {Activity_Embedding_CompleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_embedding_complete = /** @type {((inputs: Activity_Embedding_CompleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Embedding_CompleteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name}: alle Dateien indiziert`)
	return /** @type {LocalizedString} */ (`${i?.name}: all files indexed`)
});